import { gql } from '@apollo/client'

const UPDATE_DIET_EXCLUDED_ALLERGENS_DETAILS_MUTATION = gql`
  mutation updateDietExcludedAllergensDetails($id: ID!, $data: [ID!]) {
    updateDietExcludedAllergensDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      excludedAllergens {
        id
      }
    }
  }
`

export default UPDATE_DIET_EXCLUDED_ALLERGENS_DETAILS_MUTATION
